/**
 * Feature 043 — a field with saved data stays visible even if practice settings
 * later mark it not-visible: hiding a value that already exists would look like
 * data loss (edit form) or hide real encounter data (read-only display). Only an
 * empty/never-filled field is actually hidden by the not-visible setting.
 *
 * Recurses into arrays (CodeRows: `{ code, modifiers }`) and plain objects
 * (e.g. a Location) so a row/object counts as having a value if any of its
 * primitive leaves does.
 */
export function hasFieldValue(value: unknown): boolean {
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  if (typeof value === 'boolean') return true;
  if (typeof value === 'number') return true;
  if (Array.isArray(value)) return value.some(hasFieldValue);
  if (typeof value === 'object') return Object.values(value as Record<string, unknown>).some(hasFieldValue);
  return true;
}
